export default function styleNames(styles, names) {
  return String(names || '')
    .split(/\s+/)
    .filter(Boolean)
    .map(name => styles[name])
    .filter(Boolean)
    .join(' ')
}
